var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundEmptyTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1448,
    height: 224,
    viewBox: "0 0 1448 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4050_48389",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1448,
    height: 224
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1448,
    height: 224,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4050_48389)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1448,
    height: 224,
    fill: "#F4F3F6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 0.038674,
    height: 0.25
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4050_48389",
    transform: "scale(0.000345304 0.00223214)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4050_48389",
    width: 112,
    height: 112,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHAAAABwCAYAAADG4PRLAAAAAXNSR0IArs4c6QAAAk1JREFUeJzt3cttw0AQRMHOPwkrU/pGQNaPIpfETHkbmPsWXgCb7NstyXLh/ex8597RPhoX3EfjgvtoXHAfjQvuo3HBfTQuuI/GBffRuOA+GhfcR+OC+2hccB+NC+6jcfF9NE6Pd8ugh1fF6fGWDHh4ZZwe75KAM97Y/fXROD3eqQEr4PR4pwWsgtPjnRKwEk6PNzxgNZweb2jAijg93rCAVXF6vCEBK+P0eIcDVsfp8Q4F7IDT4+0O2AWnx9sVsBNOj/d1wG44Pd5XATvi9HibA3bF6fE2BeyM0+N9DNgdp8d7G1DA6fFeBlRwerynASWcHu8hoIbT490FFHF6vDWgitPjLYmN0+MtF5nWzXiNfTQuuI/GBffRuOA+GhfcR+OC+2hccB+NC+6jccF9NC64j8YF99G44D4aF9xH44L7aFxwH40L7qNxwX00LriPxgX30bjgPhoX3EfjgvtoXHAfjQvuo3HBfTQuuI/GBffRuPg+GqfHm/9GDLz5b8TA/Zd4lwSc8cZu/hsx8Cr4aJwe77SAVXB6vFMCVsLp8YYHrIbT4w0NWBGnxxsWsCpOjzckYGWcHu9wwOo4Pd6hgB1werzdAbvg9Hi7AnbC6fG+DtgNp8f7KmBHnB5vc8CuOD3epoCdcXq8jwG74/R4bwMKOD3ey4AKTo/3NKCE0+M9BNRwery7gCJOj7cGVHF6vCWxcXq85SLTuhmvsY/GBffRuOA+GhfcR+OC+2hccB+NC+6jccF9NC64j8YF99G44D4aF9xH44L7aFya+H4BdAWg6Q+Pi/sAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundEmptyTable);
export default __webpack_public_path__ + "static/media/background-empty-table.07a9f95377703f89c51663fdb2facfe3.svg";
export { ForwardRef as ReactComponent };